import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import commonStore from "../../Store/marco/commonStore";
import { abortAll } from "../../services/abortManager";
import LoginLoading from "./LoginLoading";

const SSOLoginHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("processing");
  const hasStarted = useRef(false);

  useEffect(() => {
    if (hasStarted.current) return;
    hasStarted.current = true;

    const params = new URLSearchParams(location.search);
    //////// SSO-login?code = tempCode
    const tempCode = params.get("code");

    const performSSO = async () => {
      abortAll();
      commonStore.resetAuthState();

      if (!tempCode) {
        console.warn("No tempCode provided for SSO");
        setStatus("error");
        window.location.replace("/login?ssoError=missing_code");
        return;
      }

      try {
        //////// 執行 SSO 登入
        await commonStore.ssoLogin(tempCode);

        // Reload the app so every singleton store starts with the new account.
        window.location.replace("/");
      } catch (err) {
        console.error("SSO Login Error", err);
        commonStore.resetAuthState();
        setStatus("error");
        window.location.replace("/login?ssoError=login_failed");
      }
    };

    performSSO();
  }, [location.search]);

  return (
    <LoginLoading
      status={status}
      message={
        status === "processing"
          ? "Establishing secure connection..."
          : "Authentication failed."
      }
      onBack={() => navigate("/login")}
    />
  );
};

export default SSOLoginHandler;
